import { axiosApiInstance } from 'Store';
import { userApiRequests } from 'utils/api-requests/user';
import { v4 } from 'uuid';

export const logData = (data: unknown) => {
    return axiosApiInstance({
        method: 'post',
        url: '/user/log-error',
        data: {
            data: JSON.stringify(data)
        }
    }).catch((error) => {
        const errorId = v4();
        userApiRequests.logException(error, errorId);
    });
};
